import * as types from '../actions';
import { LBL_CREW } from '../configs/labelConfigs';

const initialState = {
    status: 0,
    totalPage: 0,
    numRows: 0,
    count: '',
    activity: '',
    subactivity: '',
    discActivity: '',
    invoiceActivity: '',
    invoiceGenerateActivity: '',
    errorData: '',
    events: [],
    clients: [],
    clientContacts: [],
    locations: [],
    item: {

    },
    assUsers: [],
    skillList: [],
    otherExps: [],
    clientDetails: {},
    affiliateDetails: {},
    quoteSummary: {},
    eventSummary: '',
    eventPreviewQuote: '',
    crewChiefCount: '',
    actionLogs: [],
    shiftsList: [],
    quoteFile: '',
    invoiceFile: '',
    affiliateList: [],
    shiftDetails: '',
    calendarEvents: [],
    eventId: 0,
    shiftScheduleData: '',
    scheduleCrewList: [],
    scheduleSkillList: [],
    scheduleCrewCount: 0,
    scheduleCrewNumRows: 0,
    scheduleCrewTotalPage: 0,
    requestedCrewId: 0,
    selectedShiftDetails: [],
    previewQuoteStatus: 0,
    previewQuoteActivity: '',
    eventPreviewQuoteError: '',
    shiftSeqNumber: 1,
    email: '',
    userName: '',
    scheduleHeadingSubTitle: '',
    filterAffiliatesList: [],
    eventShiftsList: [],
    eventShiftCrewList: [],
    schedDateViewCalendarData: [],
    schedDateViewCalDateData: [],
    scheduleViewType: '',
    signature: '',
    shiftUpdateData: [],
    listEventMessages: [],
    shiftTimeChangeRequestData: {},
    unallocatedShiftsCountData: {},
    invoiceList: [],
    invoiceQuote: [],
    affAvailVeh: [],
    affAvailVehData: [],
    affVehActivity: '',
    cancelReasons: [],
    reasonStatus: '',
    reasonActivity: '',
    availabilityCrewList: [],
    availabilityCrewTotalPage: 0,
    availabilityCrewNumRows: 0,
    availabilityCrewCount: 0,
    eventClientDepartmentsList: [],
    eventDeptActivity: '',
    shiftCalendarEventsList: [],
    shiftCalendarShiftsList: [],
    travelModuleDistanceData: {},
}

export default function (state = initialState, action) {
    const response = action.response;
    let timeVar = '~~' + Date.now();

    switch (action.type) {

        case types.EVENT_LIST_SUCCESS:
            if (response.status === 200) {
                let totalPage = 1
                if (response.data.results !== undefined) {
                    totalPage = Math.ceil(response.data.count / response.data.page_size);
                }
                return {
                    ...state,
                    events: (response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,
                    activity: types.EVENT_LIST_SUCCESS,
                    totalPage: (response.data.results === undefined ? 1 : totalPage),
                    numRows: (response.data.results === undefined ? response.data.length : response.data.results.length),
                    count: response.data.count
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_LIST_ERROR,
                    errorData: response.data
                };
            }

        case types.EVENT_LIST_DOWNLOAD_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    downloadEvents: (response.data.results === undefined ? response.data : response.data.results),
                    downloadStatus: response.status,
                    downloadActivity: types.EVENT_LIST_DOWNLOAD_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    downloadStatus: response.status,
                    downloadActivity: types.EVENT_LIST_DOWNLOAD_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.EVENT_LIST_DOWNLOAD_ERROR:
            return {
                ...state,
                downloadStatus: response.status,
                downloadActivity: types.EVENT_LIST_DOWNLOAD_ERROR + timeVar,
                errorData: response.data
            };
        case types.CANCELLED_REASON_LIST_SUCCESS:
            return {
                ...state,
                reasonStatus: response.status,
                reasonActivity: types.CANCELLED_REASON_LIST_SUCCESS + timeVar,
                cancelReasons: response.data
            };


        case types.SHIFT_CREW_LIST_DOWNLOAD_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    downloadShiftCrewData: (response.data.results === undefined ? response.data : response.data.results),
                    downloadShiftCrewDataStatus: response.status,
                    downloadShiftCrewDataActivity: types.SHIFT_CREW_LIST_DOWNLOAD_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    downloadShiftCrewDataStatus: response.status,
                    downloadShiftCrewDataActivity: types.SHIFT_CREW_LIST_DOWNLOAD_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.SHIFT_CREW_LIST_DOWNLOAD_ERROR:
            return {
                ...state,
                downloadShiftCrewDataStatus: response.status,
                downloadShiftCrewDataActivity: types.SHIFT_CREW_LIST_DOWNLOAD_ERROR + timeVar,
                errorData: response.data
            };

        case types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    eventShiftStaffPDFData: (response.data),
                    eventShiftStaffPDFDataStatus: response.status,
                    eventShiftStaffPDFDataActivity: types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    eventShiftStaffPDFDataStatus: response.status,
                    eventShiftStaffPDFDataActivity: types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR:
            return {
                ...state,
                eventShiftStaffPDFDataStatus: response.status,
                eventShiftStaffPDFDataActivity: types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR + timeVar,
                errorData: response.data
            };


        case types.EVENT_MESSAGES_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    listEventMessages: response.data,
                    status: response.status,
                    activity: types.EVENT_MESSAGES_LIST_SUCCESS,
                    messageActivity: types.EVENT_MESSAGES_LIST_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_MESSAGES_LIST_ERROR,
                    messageActivity: types.EVENT_MESSAGES_LIST_ERROR + timeVar,
                    errorData: response.data
                };
            }



        case types.EVENT_MESSAGES_LIST_ERROR:
            return {
                ...state,
                status: response.status,
                activity: types.EVENT_MESSAGES_LIST_ERROR,
                messageActivity: types.EVENT_MESSAGES_LIST_ERROR + timeVar,
                errorData: response.data
            };

        case types.AVAILABLE_AFF_VEHICLE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    affAvailVeh: response.data,
                    status: response.status,
                    activity: types.AVAILABLE_AFF_VEHICLE_SUCCESS,
                    affVehActivity: types.AVAILABLE_AFF_VEHICLE_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.AVAILABLE_AFF_VEHICLE_ERROR,
                    affVehActivity: types.AVAILABLE_AFF_VEHICLE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.AVAILABLE_AFF_VEHICLE_ERROR:
            return {
                ...state,
                status: response.status,
                activity: types.AVAILABLE_AFF_VEHICLE_ERROR,
                affVehActivity: types.AVAILABLE_AFF_VEHICLE_ERROR + timeVar,
                errorData: response.data
            };
        case types.ADD_AFF_VEHICLE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    affAvailVehData: response.data,
                    status: response.status,
                    activity: types.ADD_AFF_VEHICLE_SUCCESS,
                    affVehActivity: types.ADD_AFF_VEHICLE_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.ADD_AFF_VEHICLE_ERROR,
                    affVehActivity: types.ADD_AFF_VEHICLE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.ADD_AFF_VEHICLE_SHIFT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    affAvailVehData: response.data,
                    status: response.status,
                    activity: types.ADD_AFF_VEHICLE_SHIFT_SUCCESS,
                    affVehActivity: types.ADD_AFF_VEHICLE_SHIFT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.ADD_AFF_VEHICLE_SHIFT_ERROR,
                    affVehActivity: types.ADD_AFF_VEHICLE_SHIFT_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.ADD_AFF_VEHICLE_ERROR:
            return {
                ...state,
                status: response.status,
                activity: types.ADD_AFF_VEHICLE_ERROR,
                affVehActivity: types.ADD_AFF_VEHICLE_ERROR + timeVar,
                errorData: response.data
            };
        case types.REMOVE_AFF_VEHICLE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    affAvailVehData: response.data,
                    status: response.status,
                    activity: types.REMOVE_AFF_VEHICLE_SUCCESS,
                    affVehActivity: types.REMOVE_AFF_VEHICLE_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.REMOVE_AFF_VEHICLE_ERROR,
                    affVehActivity: types.REMOVE_AFF_VEHICLE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.REMOVE_AFF_VEHICLE_SHIFT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    affAvailVehData: response.data,
                    status: response.status,
                    activity: types.REMOVE_AFF_VEHICLE_SHIFT_SUCCESS,
                    affVehActivity: types.REMOVE_AFF_VEHICLE_SHIFT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.REMOVE_AFF_VEHICLE_SHIFT_ERROR,
                    affVehActivity: types.REMOVE_AFF_VEHICLE_SHIFT_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.REMOVE_AFF_VEHICLE_ERROR:
            return {
                ...state,
                status: response.status,
                activity: types.AVAILABLE_AFF_VEHICLE_ERROR,
                affVehActivity: types.REMOVE_AFF_VEHICLE_ERROR + timeVar,
                errorData: response.data
            };

        case types.INVOICE_LIST_DOWNLOAD_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    invoiceDownloadEvents: (response.data.results === undefined ? response.data : response.data.results),
                    invoiceDownloadStatus: response.status,
                    invoiceDownloadActivity: types.INVOICE_LIST_DOWNLOAD_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    invoiceDownloadStatus: response.status,
                    invoiceDownloadActivity: types.INVOICE_LIST_DOWNLOAD_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.INVOICE_LIST_DOWNLOAD_ERROR:
            return {
                ...state,
                invoiceDownloadStatus: response.status,
                invoiceDownloadActivity: types.INVOICE_LIST_DOWNLOAD_ERROR + timeVar,
                errorData: response.data
            };


        case types.QUOTE_CLIENT_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    clients: response.data,
                    status: response.status,
                    activity: types.QUOTE_CLIENT_LIST_SUCCESS,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.QUOTE_CLIENT_LIST_ERROR,
                    errorData: response.data
                };
            }
        case types.LIST_INVOICE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    invoiceList: response.data,
                    status: response.status,
                    invoiceActivity: types.LIST_INVOICE_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    invoiceActivity: types.LIST_INVOICE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.INVOICE_PREVIEW_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    invoiceQuote: response.data,
                    status: response.status,
                    invoiceActivity: types.INVOICE_PREVIEW_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    invoiceActivity: types.INVOICE_PREVIEW_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.UPDATE_INVOICE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    invoiceActivity: types.UPDATE_INVOICE_SUCCESS,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    invoiceActivity: types.UPDATE_INVOICE_ERROR,
                    errorData: response.data
                };
            }

        case types.CLIENT_CONTACT_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    clientContacts: response.data,
                    status: response.status,
                    activity: types.CLIENT_CONTACT_LIST_SUCCESS,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.CLIENT_CONTACT_LIST_ERROR,
                    errorData: response.data
                };
            }

        case types.QUOTE_EVENT_LOCATION_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    locations: response.data.length > 0 ? response.data : [],
                    activity: types.QUOTE_EVENT_LOCATION_LIST_SUCCESS,
                }
            } else {
                return {
                    ...state,
                    status: response.status,
                    locations: [],
                    activity: types.QUOTE_EVENT_LOCATION_LIST_ERROR,
                }
            }


        case types.EVENT_ADD_SUCCESS:
            if (response.status === 201) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_ADD_SUCCESS,
                    item: {
                        affiliateId: response.data.affiliate_profile,
                        eventId: response.data.id,
                        eventTitle: response.data.title,
                        clientId: response.data.client_profile,
                        location: response.data.location,
                        startDate: response.data.start_date,
                        endDate: response.data.end_date,
                        venueName: response.data.location_detail.location.venue,
                        streetOne: response.data.location_detail.location.street1,
                        streetTwo: response.data.location_detail.location.street2,
                        city: response.data.location_detail.location.city,
                        state: response.data.location_detail.location.state,
                        country: response.data.location_detail.location.country,
                        postcode: response.data.location_detail.location.postcode,
                        googleLocation: response.data.location_detail.location.lat_long,
                    },
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_ADD_ERROR,
                    errorData: response.data
                };
            }

        case types.EVENT_EDIT_SUCCESS:
            if (response.status === 200) {

                return {
                    ...state,
                    item: {
                        eventId: response.data.id,
                        affiliateId: response.data.affiliate_profile,
                        clientId: response.data.client_profile,
                        clientContactId: response.data.client_contact,
                        eventTitle: response.data.title,
                        quoteNumber: response.data.quote_number === null ? '' : response.data.quote_number,
                        location: response.data.location,
                        venue: response.data.location_detail.location.venue,
                        streetOne: response.data.location_detail.location.street1,
                        streetTwo: response.data.location_detail.location.street2,
                        city: response.data.location_detail.location.city,
                        state: response.data.location_detail.location.state,
                        country: response.data.location_detail.location.country,
                        postcode: response.data.location_detail.location.postcode,
                        startDate: response.data.start_date,
                        endDate: response.data.end_date,
                        poNumber: response.data.po_number === null ? '' : response.data.po_number,
                        eventNotes: response.data.notes,
                        status: response.data.status,
                        created_by: response.data.created_by,
                        googleLocation: response.data.location_detail.location.lat_long,

                    },
                    status: response.status,
                    activity: types.EVENT_EDIT_SUCCESS,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_EDIT_ERROR,
                    errorData: response.data
                };
            }
        case types.EVENT_UPDATE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_UPDATE_SUCCESS,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_UPDATE_ERROR,
                    errorData: response.data
                };
            }
        case types.SEND_EVENT_MESSAGE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    sendEventActivity: types.SEND_EVENT_MESSAGE_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    sendEventActivity: types.SEND_EVENT_MESSAGE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.EVENT_DELETE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_DELETE_SUCCESS,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_DELETE_ERROR,
                    errorData: response.data
                };
            }

        case types.EVENT_CANCEL_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_CANCEL_SUCCESS,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_CANCEL_ERROR,
                    errorData: response.data
                };
            }

        case types.QUOTE_ACCEPT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    eventId: response.data.event_id,
                    signature: response.data.signature,
                    subactivity: types.QUOTE_ACCEPT_SUCCESS + timeVar,
                    activity: types.QUOTE_ACCEPT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.QUOTE_ACCEPT_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.QUOTE_REJECT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    eventId: response.data.event_id,
                    subactivity: types.QUOTE_REJECT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.QUOTE_REJECT_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.QUOTE_REQUEST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    eventId: response.data.event_id,
                    subactivity: types.QUOTE_REQUEST_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.QUOTE_REQUEST_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.QUOTE_REQUEST_ERROR:
            return {
                ...state,
                status: response.status,
                subactivity: types.QUOTE_REQUEST_ERROR + timeVar,
                errorData: response.data
            };

        case types.QUOTE_ASS_USER_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    assUsers: response.data,
                    status: response.status,
                    activity: types.QUOTE_ASS_USER_LIST_SUCCESS,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.QUOTE_ASS_USER_LIST_ERROR,
                    errorData: response.data
                };
            }
        case types.OTHER_EXP_LIST_SUCCESS:
            return {
                ...state,
                otherExps: response.data,
                status: response.status,
                subactivity: types.OTHER_EXP_LIST_SUCCESS + timeVar,
            };

        case types.CREW_AFFILIATE_SKILL_LIST_SUCCESS:
            return {
                ...state,
                skillList: response.data,
                status: response.status,
                subactivity: types.CREW_AFFILIATE_SKILL_LIST_SUCCESS + timeVar,
            };

        case types.EVENT_CLIENT_DETAILS_SUCCESS:
            return {
                ...state,
                clientDetails: response.data,
                status: response.status,
                activity: types.EVENT_CLIENT_DETAILS_SUCCESS,
            };

        case types.GENERATE_INVOICE_SUCCESS:
            return {
                ...state,
                invoiceGenerateActivity: types.GENERATE_INVOICE_SUCCESS + timeVar,
            };

        case types.GENERATE_INVOICE_ERROR:
            return {
                ...state,
                invoiceGenerateActivity: types.GENERATE_INVOICE_ERROR + timeVar,
            };


        case types.SHIFT_ADD_SUCCESS:
            if (response.status === 201) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_ADD_SUCCESS + timeVar,
                    shiftAddData: response.data
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_ADD_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.EVENT_QUOTE_SUMMARY_SUCCESS:
            return {
                ...state,
                quoteSummary: response.data,
                status: response.status,
                activity: types.EVENT_QUOTE_SUMMARY_SUCCESS,
                subactivity: types.EVENT_QUOTE_SUMMARY_SUCCESS + timeVar,
            };

        case types.EVENT_SUMMARY_SUCCESS:
            return {
                ...state,
                eventSummary: response.data,
                status: response.status,
                activity: types.EVENT_SUMMARY_SUCCESS,
                eventSummaryActivity: types.EVENT_SUMMARY_SUCCESS + timeVar,
            };

        case types.EVENT_QUOTE_PREVIEW_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    eventPreviewQuote: response.data,
                    previewQuoteStatus: response.status,
                    previewQuoteActivity: types.EVENT_QUOTE_PREVIEW_SUCCESS,
                };
            }
            else {
                return {
                    ...state,
                    previewQuoteStatus: response.status,
                    previewQuoteActivity: types.EVENT_QUOTE_PREVIEW_ERROR,
                    eventPreviewQuoteError: response.data,
                };
            }

        case types.SHIFT_INDIVIDUAL_DETAILS_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftIndividualDetails: response.data,
                    shiftIndividualStatus: response.status,
                    shiftIndividualActivity: types.SHIFT_INDIVIDUAL_DETAILS_SUCCESS + timeVar
                };
            }
            else {
                return {
                    ...state,
                    shiftIndividualStatus: response.status,
                    shiftIndividualActivity: types.SHIFT_INDIVIDUAL_DETAILS_ERROR + timeVar,
                    shiftIndividualErrorData: response.data
                };
            }
        case types.SHIFT_INDIVIDUAL_DETAILS_ERROR:
            return {
                ...state,
                shiftIndividualStatus: response.status,
                shiftIndividualActivity: types.SHIFT_INDIVIDUAL_DETAILS_ERROR + timeVar,
                shiftIndividualErrorData: response.data
            };

        case types.QUOTE_SEND_CLIENT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    eventId: response.data.event_id,
                    subactivity: types.QUOTE_SEND_CLIENT_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.QUOTE_SEND_CLIENT_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.QUOTE_SEND_CLIENT_ERROR:
            return {
                ...state,
                status: response.status,
                subactivity: types.QUOTE_SEND_CLIENT_ERROR + timeVar,
                errorData: response.data
            };

        case types.INVOICE_SEND_CLIENT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    eventId: response.data.event_id,
                    email: response.data.email,
                    userName: response.data.user_name,
                    subactivity: types.INVOICE_SEND_CLIENT_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.INVOICE_SEND_CLIENT_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.INVOICE_SEND_CLIENT_ERROR:
            return {
                ...state,
                status: response.status,
                subactivity: types.INVOICE_SEND_CLIENT_ERROR + timeVar,
                errorData: response.data
            };

        case types.QUOTE_DOWNLOAD_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    quoteFile: response.data.file_path,
                    status: response.status,
                    subactivity: types.QUOTE_DOWNLOAD_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.QUOTE_DOWNLOAD_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.QUOTE_DOWNLOAD_ERROR:
            return {
                ...state,
                status: response.status,
                subactivity: types.QUOTE_DOWNLOAD_ERROR + timeVar,
                errorData: response.data
            };


        case types.INVOICE_DOWNLOAD_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    invoiceFile: response.data.file_path,
                    status: response.status,
                    subactivity: types.INVOICE_DOWNLOAD_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.INVOICE_DOWNLOAD_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.INVOICE_DOWNLOAD_ERROR:
            return {
                ...state,
                status: response.status,
                subactivity: types.INVOICE_DOWNLOAD_ERROR + timeVar,
                errorData: response.data
            };



        case types.EVENT_CREW_CHIEF_COUNT_SUCCESS:
            return {
                ...state,
                crewChiefCount: response.data.crew_count_chief,
                status: response.status,
                subactivity: types.EVENT_CREW_CHIEF_COUNT_SUCCESS,
            };
        case types.QUOTE_USER_ACTION_LOG_SUCCESS:
            return {
                ...state,
                actionLogs: response.data,
                status: response.status,
                subactivity: types.QUOTE_USER_ACTION_LOG_SUCCESS,
            };

        case types.SHIFT_LIST_SUCCESS:
            if (response.status === 200) {
                let totalPage = Math.ceil(response.data.count / response.data.page_size);
                return {
                    ...state,
                    shiftsList: response.data.results,
                    status: response.status,
                    activity: types.SHIFT_LIST_SUCCESS,
                    totalPage: totalPage,
                    numRows: response.data.results.length,
                    count: response.data.count
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SHIFT_LIST_ERROR,
                    errorData: response.data
                };
            }

        case types.SHIFT_QUICK_UPDATE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftQuickUpdateDetails: response.data,
                    shiftQuickUpdateStatus: response.status,
                    shiftQuickUpdateActivity: types.SHIFT_QUICK_UPDATE_SUCCESS + timeVar
                };
            }
            else {
                return {
                    ...state,
                    shiftQuickUpdateStatus: response.status,
                    shiftQuickUpdateActivity: types.SHIFT_QUICK_UPDATE_ERROR + timeVar,
                    shiftQuickUpdateErrorData: response.data
                };
            }
        case types.SHIFT_QUICK_UPDATE_ERROR:
            return {
                ...state,
                shiftQuickUpdateStatus: (response && response.status) ? response.status : '',
                shiftQuickUpdateActivity: types.SHIFT_QUICK_UPDATE_ERROR + timeVar,
                shiftQuickUpdateErrorData: response.data
            };


        case types.EVENT_CLIENT_AFFILIATE_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    affiliateList: response.data.affiliates,
                    status: response.status,
                    activity: types.EVENT_CLIENT_AFFILIATE_LIST_SUCCESS,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_CLIENT_AFFILIATE_LIST_ERROR,
                    errorData: response.data
                };
            }

        case types.EVENT_SHIFT_UPDATE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.EVENT_SHIFT_UPDATE_SUCCESS + timeVar,
                    activity: types.EVENT_SHIFT_UPDATE_SUCCESS,
                    shiftUpdateData: response.data,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.EVENT_SHIFT_UPDATE_ERROR + timeVar,
                    activity: types.EVENT_SHIFT_UPDATE_ERROR,
                    errorData: response.data
                };
            }

        case types.SHIFT_DELETE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SHIFT_DELETE_SUCCESS,
                    subactivity: types.SHIFT_DELETE_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SHIFT_DELETE_ERROR,
                    subactivity: types.SHIFT_DELETE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.ADD_REMOVE_VEHICLE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.ADD_REMOVE_VEHICLE_SUCCESS,
                    subactivity: types.ADD_REMOVE_VEHICLE_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.ADD_REMOVE_VEHICLE_ERROR,
                    subactivity: types.ADD_REMOVE_VEHICLE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.ADD_REMOVE_VEHICLE_SHIFT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.ADD_REMOVE_VEHICLE_SHIFT_SUCCESS,
                    subactivity: types.ADD_REMOVE_VEHICLE_SHIFT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.ADD_REMOVE_VEHICLE_SHIFT_ERROR,
                    subactivity: types.ADD_REMOVE_VEHICLE_SHIFT_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.SHIFT_EDIT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftDetails: response.data,
                    status: response.status,
                    subactivity: types.SHIFT_EDIT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_EDIT_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.SHIFT_CANCEL_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SHIFT_CANCEL_SUCCESS,
                    subactivity: types.SHIFT_CANCEL_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.SHIFT_CANCEL_ERROR,
                    subactivity: types.SHIFT_CANCEL_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.EVENTS_CALENDAR_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    calendarEvents: response.data,
                    status: response.status,
                    subactivity: types.EVENTS_CALENDAR_LIST_SUCCESS,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.EVENTS_CALENDAR_LIST_ERROR,
                    errorData: response.data
                };
            }

        case types.SHIFT_SUMMARY_SUCCESS: // USED IN SHIFT DETAILS SLIDER FROM SHIFT LISTING 
            if (response.status === 200) {
                return {
                    ...state,
                    shiftSliderDetails: response.data,
                    shiftSliderStatus: response.status,
                    shiftSliderActivity: types.SHIFT_SUMMARY_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    shiftSliderStatus: response.status,
                    shiftSliderActivity: types.SHIFT_SUMMARY_ERROR + timeVar,
                    shiftSliderErrorData: (response.data !== undefined) ? response.data : []
                };
            }

        case types.SHIFT_SUMMARY_ERROR:
            return {
                ...state,
                shiftSliderStatus: response.status,
                shiftSliderActivity: types.SHIFT_SUMMARY_ERROR + timeVar,
                shiftSliderErrorData: (response.data !== undefined) ? response.data : []
            };

        case types.SHIFT_SUMMARY_ALL_CREW_SUCCESS: // USED IN SHIFT DETAILS SLIDER FROM SHIFT LISTING 
            if (response.status === 200) {
                return {
                    ...state,
                    shiftSkillAllCrewData: response.data,
                    shiftSliderStatus: response.status,
                    shiftSliderActivity: types.SHIFT_SUMMARY_ALL_CREW_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    shiftSliderStatus: response.status,
                    shiftSliderActivity: types.SHIFT_SUMMARY_ALL_CREW_ERROR + timeVar,
                    shiftSliderErrorData: (response.data !== undefined) ? response.data : []
                };
            }

        case types.SHIFT_SUMMARY_ALL_CREW_ERROR:
            return {
                ...state,
                shiftSliderStatus: response.status,
                shiftSliderActivity: types.SHIFT_SUMMARY_ALL_CREW_ERROR + timeVar,
                shiftSliderErrorData: (response.data !== undefined) ? response.data : []
            };

        case types.SHIFT_GET_DETAILS_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftDataDetails: response.data,
                    shiftDataStatus: response.status,
                    shiftDataActivity: types.SHIFT_GET_DETAILS_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    shiftDataStatus: response.status,
                    shiftDataActivity: types.SHIFT_GET_DETAILS_ERROR + timeVar,
                    shiftErrorData: response.data
                };
            }
        case types.SHIFT_GET_DETAILS_ERROR:
            return {
                ...state,
                shiftDataStatus: response.status,
                shiftDataActivity: types.SHIFT_GET_DETAILS_ERROR + timeVar,
                shiftErrorData: response.data
            };

        case types.SHIFT_SCHEDULE_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftScheduleData: response.data,
                    status: response.status,
                    subactivity: types.SHIFT_SCHEDULE_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_SCHEDULE_LIST_ERROR + timeVar,
                    errorData: response.data
                };
            }


        case types.SHIFT_SCHEDULE_CREW_SUCCESS:
            if (response.status === 200) {
                let totalPage = 1
                if (response.data.results !== undefined) {
                    totalPage = Math.ceil(response.data.count / response.data.page_size);
                }
                return {
                    ...state,
                    scheduleCrewList: (response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,
                    subactivity: types.SHIFT_SCHEDULE_CREW_SUCCESS + timeVar,
                    scheduleCrewTotalPage: (response.data.results === undefined ? 1 : totalPage),
                    scheduleCrewNumRows: (response.data.results === undefined ? response.data.length : response.data.results.length),
                    scheduleCrewCount: response.data.count
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_SCHEDULE_CREW_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.CREW_AVAILABILITY_REPORT_SUCCESS:
            if (response.status === 200) {
                let availabilityTotalPage = 1
                if (response.data.results !== undefined) {
                    availabilityTotalPage = Math.ceil(response.data.count / response.data.page_size);
                }
                return {
                    ...state,
                    availabilityCrewList: (response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,
                    subactivity: types.CREW_AVAILABILITY_REPORT_SUCCESS + timeVar,
                    availabilityCrewTotalPage: (response.data.results === undefined ? 1 : availabilityTotalPage),
                    availabilityCrewNumRows: (response.data.results === undefined ? response.data.length : response.data.results.length),
                    availabilityCrewCount: response.data.count
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.CREW_AVAILABILITY_REPORT_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.CREW_AVAIL_SUMMARY_REPORT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    availabilitySummary: (response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,
                    subactivity: types.CREW_AVAIL_SUMMARY_REPORT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.CREW_AVAIL_SUMMARY_REPORT_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.SHIFT_SKILL_CREW_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftSkillCrewData: response.data,
                    shiftSkillCrewStatus: response.status,
                    shiftSkillCrewActivity: types.SHIFT_SKILL_CREW_LIST_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    shiftSkillCrewStatus: response.status,
                    shiftSkillCrewActivity: types.SHIFT_SKILL_CREW_LIST_ERROR + timeVar,
                    shiftSkillCrewErrorData: (response.data !== undefined) ? response.data : []
                };
            }
        case types.SHIFT_SKILL_CREW_LIST_ERROR:
            return {
                ...state,
                shiftSkillCrewStatus: response.status,
                shiftSkillCrewActivity: types.SHIFT_SKILL_CREW_LIST_ERROR + timeVar,
                shiftSkillCrewErrorData: (response.data !== undefined) ? response.data : []
            };

        case types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    requestedCrewData: {
                        requestedCrewId: response.data.crew_profile_id,
                        requestedCrewName: response.data.crew_profile_name,
                        requestedCrewChief: response.data.is_crew_chief,
                        arrScheduleShiftId: response.data.schedule_shift_id,
                        requestedShift: response.data.shif_name,
                        requestedSkillId: response.data.skill,
                        requestedSkillName: response.data.skill_name
                    },
                    status: response.status,
                    subactivity: types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_ERROR + timeVar,
                    errorData: response.data
                };
            }

        case types.SCHEDULE_DATE_VIEW_SUCCESS:
            if (response.status === 200) {

                return {
                    ...state,
                    scheduleDateViewData: response.data,
                    status: response.status,
                    activity: types.SCHEDULE_DATE_VIEW_SUCCESS + timeVar,
                    scheduleViewType: ' - Date View'
                };
            } else {
                return {
                    ...state,
                    status: (response && response.status) ? response.status : 0,
                    activity: types.SCHEDULE_DATE_VIEW_ERROR + timeVar,
                    errorData: (response && response.data) ? response.data : [],
                    scheduleViewType: ' - Date View'
                };
            }
        case types.SCHEDULE_DATE_VIEW_ERROR:
            return {
                ...state,
                status: (response && response.status) ? response.status : 0,
                activity: types.SCHEDULE_DATE_VIEW_ERROR + timeVar,
                errorData: (response && response.data) ? response.data : [],
                scheduleViewType: ' - Date View'
            };

        case types.SCHEDULE_CREW_VIEW_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    scheduleCrewViewData: response.data,
                    status: response.status,
                    activity: types.SCHEDULE_CREW_VIEW_SUCCESS + timeVar,
                    scheduleViewType: ' - ' + LBL_CREW + ' View',
                };
            } else {
                return {
                    ...state,
                    status: (response && response.status) ? response.status : 0,
                    activity: types.SCHEDULE_CREW_VIEW_ERROR + timeVar,
                    errorData: (response && response.data) ? response.data : [],
                    scheduleViewType: ' - ' + LBL_CREW + ' View',
                };
            }
        case types.SCHEDULE_CREW_VIEW_ERROR:
            return {
                ...state,
                status: (response && response.status) ? response.status : 0,
                activity: types.SCHEDULE_CREW_VIEW_ERROR + timeVar,
                errorData: (response && response.data) ? response.data : [],
                scheduleViewType: ' - ' + LBL_CREW + ' View',
            };

        case types.GET_SHIFT_IDS_FOR_SCHEDULE:
            return {
                ...state,
                selectedShiftDetails: action.data
            }

        case types.CLEAR_SHIFT_IDS_FOR_SCHEDULE:
            return {
                ...state,
                selectedShiftDetails: []
            }

        case types.FILTER_CLIENTS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    filterClientsList: response && response.data ? response.data : [],
                    filterStatus: response && response.status ? response.status : '',
                    filterActivity: types.FILTER_CLIENTS_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    filterStatus: response && response.status ? response.status : '',
                    filterActivity: types.FILTER_CLIENTS_LIST_ERROR + timeVar,
                    filterErrorData: response && response.data ? response.data : []
                };
            }
        case types.FILTER_CLIENTS_LIST_ERROR:
            return {
                ...state,
                filterStatus: response && response.status ? response.status : '',
                filterActivity: types.FILTER_CLIENTS_LIST_ERROR + timeVar,
                filterErrorData: response && response.data ? response.data : []
            };

        case types.SHIFTS_FILTER_EVENTS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftsFilterEventsList: response.data,
                    filterStatus: response.status,
                    filterActivity: types.SHIFTS_FILTER_EVENTS_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    filterStatus: response.status,
                    filterActivity: types.SHIFTS_FILTER_EVENTS_LIST_ERROR + timeVar,
                    filterErrorData: response.data
                };
            }
        case types.SHIFTS_FILTER_EVENTS_LIST_ERROR:
            return {
                ...state,
                filterStatus: response.status,
                filterActivity: types.SHIFTS_FILTER_EVENTS_LIST_ERROR + timeVar,
                filterErrorData: response.data
            };

        case types.SHIFTS_FILTER_SHIFTS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftsFilterShiftsList: response.data,
                    filterStatus: response.status,
                    filterActivity: types.SHIFTS_FILTER_SHIFTS_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    filterStatus: response.status,
                    filterActivity: types.SHIFTS_FILTER_SHIFTS_LIST_ERROR + timeVar,
                    filterErrorData: response.data
                };
            }
        case types.SHIFTS_FILTER_SHIFTS_LIST_ERROR:
            return {
                ...state,
                filterStatus: response.status,
                filterActivity: types.SHIFTS_FILTER_SHIFTS_LIST_ERROR + timeVar,
                filterErrorData: response.data
            };

        case types.SHIFTS_FILTER_LOCATIONS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    shiftsFilterLocationsList: response.data,
                    filterStatus: response.status,
                    filterActivity: types.SHIFTS_FILTER_LOCATIONS_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    filterStatus: response.status,
                    filterActivity: types.SHIFTS_FILTER_LOCATIONS_LIST_ERROR + timeVar,
                    filterErrorData: response.data
                };
            }
        case types.SHIFTS_FILTER_LOCATIONS_LIST_ERROR:
            return {
                ...state,
                filterStatus: response.status,
                filterActivity: types.SHIFTS_FILTER_LOCATIONS_LIST_ERROR + timeVar,
                filterErrorData: response.data
            };


        case types.EVENTS_FILTER_EVENTS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    eventsFilterEventsList: response.data,
                    eventsFilterStatus: response.status,
                    eventsFilterActivity: types.EVENTS_FILTER_EVENTS_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    eventsFilterErrorData: response.data,
                    eventsFilterStatus: response.status,
                    eventsFilterActivity: types.EVENTS_FILTER_EVENTS_LIST_ERROR + timeVar,
                };
            }
        case types.EVENTS_FILTER_EVENTS_LIST_ERROR:
            return {
                ...state,
                eventsFilterErrorData: response && response.data && response.data.length > 0 ? response.data : [],
                eventsFilterStatus: (response && response.status) ? response.status : '',
                eventsFilterActivity: types.EVENTS_FILTER_EVENTS_LIST_ERROR + timeVar,
            };


        case types.EVENTS_FILTER_LOCATIONS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    eventsFilterLocationsList: response.data,
                    eventsFilterStatus: response.status,
                    eventsFilterActivity: types.EVENTS_FILTER_LOCATIONS_LIST_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    eventsFilterStatus: response.status,
                    eventsFilterActivity: types.EVENTS_FILTER_LOCATIONS_LIST_ERROR + timeVar,
                    eventsFilterErrorData: response.data
                };
            }
        case types.EVENTS_FILTER_LOCATIONS_LIST_ERROR:
            return {
                ...state,
                eventsFilterStatus: (response && response.status) ? response.status : '',
                eventsFilterActivity: types.EVENTS_FILTER_LOCATIONS_LIST_ERROR + timeVar,
                eventsFilterErrorData: (response && response.data && response.data.length > 0) ? response.data : []
            };

        case types.SHIFT_SEQ_NUMBER_SUCCESS:
            return {
                ...state,
                shiftSeqNumber: response.data.seq_no
            }

        case types.EVENT_POPUP_ID_SET:
            return {
                ...state,
                eventPopupId: action.data
            }

        case types.EVENT_POPUP_ID_RESET:
            return {
                ...state,
                eventPopupId: ''
            };  // action.data

        case types.SHIFT_POPUP_ID_SET:
            return {
                ...state,
                shiftPopupId: action.data
            }

        case types.SHIFT_POPUP_ID_RESET:
            return {
                ...state,
                shiftPopupId: ''
            }; // action.data     

        case types.CLEAR:
            return {
                ...state,
                // status:0,
                activity: types.CLEAR,
            }

        case types.EVENT_COMPLETE_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_COMPLETE_SUCCESS + timeVar,
                };
            }
            else {
                return {
                    ...state,
                    status: response.status,
                    activity: types.EVENT_COMPLETE_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.EVENT_COMPLETE_ERROR:
            return {
                ...state,
                status: response.status,
                activity: types.EVENT_COMPLETE_ERROR + timeVar,
                errorData: response.data
            };


        case types.SCHEDULE_SHIFT_CREW_SUCCESS:
            if (response.status === 200) {
                let totalPage = 1
                if (response.data.results !== undefined) {
                    totalPage = Math.ceil(response.data.count / response.data.page_size);
                }
                return {
                    ...state,
                    scheduleCrewList: (response.data.results.crews === undefined ? response.data.results.crews : response.data.results.crews),
                    status: response.status,
                    scheduleSkillList: (response.data.results.skills === undefined ? response.data.results.skills : response.data.results.skills),
                    subactivity: types.SCHEDULE_SHIFT_CREW_SUCCESS + timeVar,
                    scheduleCrewTotalPage: (response.data.results.crews === undefined ? 1 : totalPage),
                    scheduleCrewNumRows: (response.data.results.crews === undefined ? 0 : response.data.results.crews.length),
                    scheduleCrewCount: response.data.count
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SCHEDULE_SHIFT_CREW_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.SCHEDULE_SHIFT_CREW_ERROR:
            return {
                ...state,
                status: response.status,
                subactivity: types.SCHEDULE_SHIFT_CREW_ERROR + timeVar,
                errorData: response.data
            };


        case types.EVENT_DISCOUNT_EDIT_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    discActivity: types.EVENT_DISCOUNT_EDIT_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    discActivity: types.EVENT_DISCOUNT_EDIT_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.EVENT_DISCOUNT_EDIT_ERROR:
            return {
                ...state,
                status: response.status,
                discActivity: types.EVENT_DISCOUNT_EDIT_ERROR + timeVar,
                errorData: response.data
            };

        case types.FILTER_AFFILIATE_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    filterStatus: response.status,
                    filterActivity: types.FILTER_AFFILIATE_LIST_SUCCESS + timeVar,
                    filterAffiliatesList: response.data.affiliates
                };
            } else {
                return {
                    ...state,
                    filterStatus: response.status,
                    filterActivity: types.FILTER_AFFILIATE_LIST_ERROR + timeVar,
                    filterErrorData: response.data
                };
            }
        case types.FILTER_AFFILIATE_LIST_ERROR:
            return {
                ...state,
                filterStatus: response.status,
                filterActivity: types.FILTER_AFFILIATE_LIST_ERROR + timeVar,
                filterErrorData: response.data
            };

        case types.EVENT_SHIFTS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.EVENT_SHIFTS_LIST_SUCCESS + timeVar,
                    eventShiftsList: response.data ? response.data : []
                };
            } else {
                return {
                    ...state,
                    status: response && response.status ? response.status : '',
                    subactivity: types.EVENT_SHIFTS_LIST_ERROR + timeVar,
                    errorData: response && response.data ? response.data : []
                };
            }
        case types.EVENT_SHIFTS_LIST_ERROR:
            return {
                ...state,
                status: response && response.status ? response.status : '',
                subactivity: types.EVENT_SHIFTS_LIST_ERROR + timeVar,
                errorData: response && response.data ? response.data : []
            };

        case types.EVENT_SHIFT_CREW_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.EVENT_SHIFT_CREW_LIST_SUCCESS + timeVar,
                    eventShiftCrewList: response.data ? response.data : []
                };
            } else {
                return {
                    ...state,
                    status: response && response.status ? response.status : '',
                    subactivity: types.EVENT_SHIFT_CREW_LIST_ERROR + timeVar,
                    errorData: response && response.data ? response.data : []
                };
            }
        case types.EVENT_SHIFT_CREW_LIST_ERROR:
            return {
                ...state,
                status: response && response.status ? response.status : '',
                subactivity: types.EVENT_SHIFT_CREW_LIST_ERROR + timeVar,
                errorData: response && response.data ? response.data : []
            };

        case types.SCHEDULE_DATE_VIEW_CALENDAR_SUCCESS:
            if (response && response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SCHEDULE_DATE_VIEW_CALENDAR_SUCCESS + timeVar,
                    schedDateViewCalendarData: response.data ? response.data : [],
                    scheduleViewType: ' - Date View'
                };
            } else {
                return {
                    ...state,
                    status: response && response.status ? response.status : '',
                    subactivity: types.SCHEDULE_DATE_VIEW_CALENDAR_ERROR + timeVar,
                    errorData: response && response.data ? response.data : [],
                    scheduleViewType: ' - Date View'
                };
            }
        case types.SCHEDULE_DATE_VIEW_CALENDAR_ERROR:
            return {
                ...state,
                status: response && response.status ? response.status : '',
                subactivity: types.SCHEDULE_DATE_VIEW_CALENDAR_ERROR + timeVar,
                errorData: response && response.data ? response.data : [],
                scheduleViewType: ' - Date View'
            };

        case types.SCHED_DATE_VIEW_CALENDAR_DATE_SUCCESS:
            if (response && response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SCHED_DATE_VIEW_CALENDAR_DATE_SUCCESS + timeVar,
                    schedDateViewCalDateData: response.data ? response.data : []
                };
            } else {
                return {
                    ...state,
                    status: response && response.status ? response.status : '',
                    subactivity: types.SCHED_DATE_VIEW_CALENDAR_DATE_ERROR + timeVar,
                    errorData: response && response.data ? response.data : []
                };
            }
        case types.SCHED_DATE_VIEW_CALENDAR_DATE_ERROR:
            return {
                ...state,
                status: response && response.status ? response.status : '',
                subactivity: types.SCHED_DATE_VIEW_CALENDAR_DATE_ERROR + timeVar,
                errorData: response && response.data ? response.data : []
            };

        case types.SCHEDULE_SET_SUB_TITLE_FROM_TO_DATE:
            return {
                ...state,
                scheduleHeadingSubTitle: action.data ? action.data : '',
            };

        case types.SHIFT_TIME_CHANGE_REQUEST_SUCCESS:
            if (response && response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.SHIFT_TIME_CHANGE_REQUEST_SUCCESS + timeVar,
                    shiftTimeChangeRequestData: response.data ? response.data : {}
                };
            } else {
                return {
                    ...state,
                    status: response && response.status ? response.status : '',
                    subactivity: types.SHIFT_TIME_CHANGE_REQUEST_ERROR + timeVar,
                    errorData: response && response.data ? response.data : []
                };
            }
        case types.SHIFT_TIME_CHANGE_REQUEST_ERROR:
            return {
                ...state,
                status: response && response.status ? response.status : '',
                subactivity: types.SHIFT_TIME_CHANGE_REQUEST_ERROR + timeVar,
                errorData: response && response.data ? response.data : []
            };

        case types.UNALLOCATED_SHIFTS_COUNT_SUCCESS:
            if (response && response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    subactivity: types.UNALLOCATED_SHIFTS_COUNT_SUCCESS + timeVar,
                    unallocatedShiftsCountData: response.data ? response.data : {}
                };
            } else {
                return {
                    ...state,
                    status: response && response.status ? response.status : '',
                    subactivity: types.UNALLOCATED_SHIFTS_COUNT_ERROR + timeVar,
                    errorData: response && response.data ? response.data : {}
                };
            }
        case types.UNALLOCATED_SHIFTS_COUNT_ERROR:
            return {
                ...state,
                status: response && response.status ? response.status : '',
                subactivity: types.UNALLOCATED_SHIFTS_COUNT_ERROR + timeVar,
                errorData: response && response.data ? response.data : {}
            };

        case types.EVENT_AFFILIATE_DETAILS_SUCCESS:
            return {
                ...state,
                affiliateDetails: response.data,
                status: response.status,
                activity: types.EVENT_AFFILIATE_DETAILS_SUCCESS,
            };
        case types.EVENT_AFFILIATE_DETAILS_ERROR:
            return {
                ...state,
                affiliateDetails: {},
                status: response.status,
                activity: types.EVENT_AFFILIATE_DETAILS_ERROR,
            };


        case types.EVENT_CLIENT_DEPARTMENTS_LIST_SUCCESS:
            if (response.status === 200) {
                return {
                    ...state,
                    status: response.status,
                    eventClientDepartmentsList: response.data,
                    eventDeptActivity: types.EVENT_CLIENT_DEPARTMENTS_LIST_SUCCESS + timeVar,
                };
            } else {
                return {
                    ...state,
                    status: response.status,
                    eventDeptActivity: types.EVENT_CLIENT_DEPARTMENTS_LIST_ERROR + timeVar,
                    errorData: response.data
                };
            }
        case types.EVENT_CLIENT_DEPARTMENTS_LIST_ERROR:
            return {
                ...state,
                status: response.status,
                eventDeptActivity: types.EVENT_CLIENT_DEPARTMENTS_LIST_ERROR + timeVar,
                errorData: response.data
            };


        case types.SHIFT_CALENDAR_EVENT_LIST_SUCCESS:
            return {
                ...state,
                shiftCalendarEventsList: response.data && Array.isArray(response.data) ? response.data : [],
                status: response.status,
                subactivity: types.SHIFT_CALENDAR_EVENT_LIST_SUCCESS + timeVar,
            };
        case types.SHIFT_CALENDAR_EVENT_LIST_ERROR:
            return {
                ...state,
                shiftCalendarEventsList: [],
                status: response.status,
                subactivity: types.SHIFT_CALENDAR_EVENT_LIST_ERROR + timeVar,
            };

        case types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_SUCCESS:
            return {
                ...state,
                shiftCalendarShiftsList: response.data ? response.data : [],
                status: response.status,
                subactivity: types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_SUCCESS + timeVar,
            };
        case types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_ERROR:
            return {
                ...state,
                shiftCalendarShiftsList: [],
                status: response?.status ? response.status : '',
                subactivity: types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_ERROR + timeVar,
            };
        case types.SHIFT_CALC_DISTANCE_DEPT_LOC_SUCCESS:
            return {
                ...state,
                travelModuleDistanceData: response.data?.distance_miles ? response.data : { distance_miles: 0, duration_hh_mm: 0.0 },
                status: response.status,
                subactivity: types.SHIFT_CALC_DISTANCE_DEPT_LOC_SUCCESS + timeVar,
            };
        case types.SHIFT_CALC_DISTANCE_DEPT_LOC_ERROR:
            return {
                ...state,
                travelModuleDistanceData: { distance_miles: 0, duration_hh_mm: 0.0 }, 
                status: response.status,
                subactivity: types.SHIFT_CALC_DISTANCE_DEPT_LOC_ERROR + timeVar,
            };

        default:
            return state;

    }
}